export class AuthRoutes {
  public static ROUTES = {
    Login: {
      path: 'login',
      fullPath: 'login',
    },
    RequestResetPassword: {
      path: 'request-reset-password',
      fullPath: 'request-reset-password',
    },
    ResetPassword: {
      path: 'reset-password/token/:id',
      fullPath: 'reset-password/token',
    },
  };
}
